<template>
  <div class="experiment mb-15">
  </div>
</template>
<script>
import {api_booking} from '@/services/iot/api_booking';
const apiBooking = new api_booking(process.env.VUE_APP_BASE_URL);
import { api_management } from "@/services/iot/api_management";
const apiManagement = new api_management(process.env.VUE_APP_BASE_URL);

export default {
  name: "group-experiment-index",
  components: {
  },
  props: {
    par: String,
  },
  mixins: [],
  data: function () {
    return {
      authorized: false,
      current:{
        school_id: null,
        username: null,
        user_level: "USER",
        auth_token: null,
        experiment: null,
        equipment_id: null,
      },
      api:{
        schools:[],
        book_slots: [],
        slots: [],
        school_id: null,
        school_name: null,
        school_chi_name: null,
        school_logo_url: "",
        eStatus: "",
        daily_slots: [],
      },
    };
  },
  created: function () {
  },
  mounted: function () {    
    var self = this;
    //self.$store.commit("showSnackBar", "Prepareing experiment...");
    
    self.current.school_id = self.$store.state.user.school_id;
    self.current.username = self.$store.state.user.username;
    self.current.user_level = self.$store.state.user.user_level;
    self.current.auth_token = self.$store.state.user.auth_token;
    self.school_id = self.$route.params.school_id;
    self.experiment = self.$route.query.experiment;
    self.equipment_id = self.$route.query.equipment;
    if(self.experiment!=undefined && self.equipment_id != undefined){
      if(self.$i18n.locale=='tc'){
        self.selected_experiment = self.experimentNameTranslate[self.experiment] + " - " + self.setTranslate[self.equipment_id];
      }
      else {
        self.selected_experiment = self.experiment.toUpperCase() + " - " + self.equipment_id;
      }
    }
    //self.form.school = self.school_id;
    self.getSchool();
  },
  methods: {
    checkAuthorized: function(){
      var self = this;
      let user_level = self.$store.state.user.user_level;
      let user_school = self.$store.state.user.school_id;
      if(  ( (user_level=="INCHARGE") && user_school==self.school_id ) ||  user_level=="ADMIN" ){
        self.authorized = true;
      }
      else {
        self.authorized = false;
      }
    },
    getSchool(){
      var self = this;
      apiBooking.getSchool(self.school_id)
      .then((response) => {
          self.api.school_id = response.school;
          self.api.school_name = response.school_name;
          self.api.school_chi_name = response.school_chi_name;
          if(JSON.parse(response.school_logo)!=null){
            self.api.school_logo_url = JSON.parse(response.school_logo).url;
          }
          else {
            self.api.school_logo_url = "";
          }
          self.$emit("info", {school_id: self.api.school_id, school_name: self.api.school_name, school_chi_name: self.api.school_chi_name, school_logo_url: self.api.school_logo_url});
      });
    },
  },  
};
</script>